import { formatCurrency, parseCurrency } from "./invoiceUtils";
import { roundMoney } from "../utils/money.mjs";

const invoicesForClient = (client, invoices = []) => invoices.filter((invoice) => (
  invoice.clientId
    ? invoice.clientId === client.id
    : invoice.client === client.name
));

const summarizeClientFinancials = (client, invoices = []) => {
  const matching = invoicesForClient(client, invoices);
  const currencies = matching.length
    ? [...new Set(matching.map((invoice) => invoice.currency || client.currency || "EUR"))]
    : [client.currency || "EUR"];

  return currencies.sort().map((currency) => {
    const currencyInvoices = matching.filter((invoice) => (invoice.currency || client.currency || "EUR") === currency);
    const lifetime = currencyInvoices.reduce(
      (sum, invoice) => roundMoney(sum + parseCurrency(invoice.amount), currency),
      0,
    );
    const outstanding = currencyInvoices.reduce((sum, invoice) => {
      if (invoice.status === "Paid") return sum;
      return roundMoney(sum + parseCurrency(invoice.amount) - Number(invoice.paidAmount || 0), currency);
    }, 0);
    return { currency, lifetime, outstanding };
  });
};

const formatFinancialSummary = (summary, key) => summary
  .map((item) => formatCurrency(item[key], item.currency))
  .join(" + ");

export const withClientFinancials = (client, invoices = []) => {
  const financials = summarizeClientFinancials(client, invoices);
  return {
    ...client,
    financials,
    outstanding: formatFinancialSummary(financials, "outstanding"),
    lifetime: formatFinancialSummary(financials, "lifetime"),
  };
};

export { invoicesForClient, summarizeClientFinancials };
